<template>
	<Teleport :to="attach">
		<div class="mdc-snackbar" ref="snackbarRef">
			<div class="mdc-snackbar__surface">
				<div class="mdc-snackbar__label" aria-atomic="false" v-html="message"></div>
				<div class="mdc-snackbar__actions" aria-atomic="true">
					<button type="button" class="mdc-button mdc-button--unelevated mdc-snackbar__action" @click="options.action" v-if="options.action && options.actionLabel">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label" v-html="options.actionLabel"></span>
					</button>
					<button class="mdc-icon-button" @click="close" v-show="!options.hideClose">
						<span class="mdc-icon-button__ripple"></span>
						<i class="material-icons mdc-icon-button__icon" aria-hidden="true">close</i>
					</button>
				</div>
			</div>
		</div>
	</Teleport>
</template>

<script setup>
// Dependencies
import { MDCSnackbar } from '@material/snackbar'
import { onMounted, ref, watch } from 'vue'
import { emitter } from './index'

const props = defineProps({
	attach: {
		type: String,
		default: `body`,
	},
})

const defaults = {
	actionLabel: ``,
	action: () => ({}),
	timeout: 5000,
}

const message = ref('')
const options = ref({})
const queued = ref([])

let snackbar
const snackbarRef = ref()
onMounted(() => {
	snackbar = new MDCSnackbar(snackbarRef.value)
	snackbar.listen(`MDCSnackbar:closed`, () => {
		queued.value.splice(0, 1)
	})

	emitter.on('show', ({msg, options}) => {
		queued.value.push({ msg, opts: options, })
	})

	emitter.on('hide', () => {
		snackbar.close()
		queued.value.splice(0, 1)
	})
})

watch(() => queued, (items) => {
	const [queue] = items.value
	if (queue) {
		const { msg, opts } = queue
		options.value = {...defaults, ...opts}
		message.value = msg
		snackbar.timeoutMs = options.value.timeout
		snackbar.open()
	}

}, {
	deep: true,
})


const close = () => {
	snackbar.close()
}

</script>

<style scoped lang="scss">
@use '@material/snackbar/mdc-snackbar';
@use "@material/button/styles";
@use "@material/icon-button/styles" as mdc-icon-button;

.mdc-snackbar {
	z-index: 90;
}

.mdc-icon-button {
	color: var(--color--primary-light);
}

</style>
